import * as React from 'react';
import styled from 'react-emotion';
import { screenWidths } from '../../utils/constants';

import { LightTitle, blueScrollbar, grid } from '../Common';
import AspectRatioImg, { AspectRatioImgContainer } from '../AspectRatioImage';

import QuieneSomos from './QuienesSomos';
import Equipo from './Equipo';
import Colaboradores from './Colaboradores';
import Visitanos from './Visitanos';

const AboutPageContainer = styled.div`
  background-color: white;
  z-index: 95;
  height: 100vh;
  position: fixed;
  top: 0;
  width: 100%;
  padding-left: 480px;
  transition: transform 0.5s;
  transform: translate(-100%, 0);
  display: none;
  @media screen and (min-width: ${screenWidths.lg}px) {
    display: block;
  }
  ${props => props.isOpen && `
    transform: translate(0, 0);
  `}
`;

const ContentWrapper = styled.div`
  ${grid.right}
  padding: 20px 20px;
`;

const Content = styled.div`
  overflow: scroll;
  height: 98vh;
  padding: 10px 100px 0 0;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #818578;
  }

  @media screen and (min-width: ${screenWidths.lg}px) {
    display: block;
  }
`;

export const AboutPageContent = ({ aboutInfo }) => (
  <div>
    <QuieneSomos
      title={aboutInfo.pageTitle}
      mainImage={aboutInfo.mainImage.file.url}
      description={aboutInfo.description.description}
      />

      <Equipo
        title={aboutInfo.teamSectionTitle}
        team={aboutInfo.team}
      />

      <Colaboradores
        title={aboutInfo.colaboradorTitle}
        colaboradores={aboutInfo.colaboradores}
      />

      <Visitanos
        title={aboutInfo.contactSectionTitle}
        address={aboutInfo.address}
        email={aboutInfo.contactEmail}
        number={aboutInfo.phoneNumber}

      />

    {aboutInfo.teamPhoto &&
        <img className={"imgteam"} src={aboutInfo.teamPhoto.file.url} />
    }

  </div>
);

const AboutPage = ({ isOpen, aboutInfo, setAboutPageRef }) => {
  return (
    <AboutPageContainer isOpen={isOpen}>
      <ContentWrapper>
        <Content innerRef={setAboutPageRef}>
          <AboutPageContent aboutInfo={aboutInfo} />
        </Content>
      </ContentWrapper>
    </AboutPageContainer>
  )
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/components/About/AboutPage.js